import { render, staticRenderFns } from "./ScreensaverManager.vue?vue&type=template&id=2960460a&scoped=true&"
import script from "./ScreensaverManager.vue?vue&type=script&lang=ts&"
export * from "./ScreensaverManager.vue?vue&type=script&lang=ts&"
import style0 from "./ScreensaverManager.vue?vue&type=style&index=0&id=2960460a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2960460a",
  null
  
)

export default component.exports